import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterRequestCustomerScheduleServiceService {

  constructor(private http: HttpClient) { }

  GetData(Token: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterRequestCustomerSchedule?token=" + Token).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_List_Interface>
      })
    )
  }

  GetModir(Token: String): Observable<Array<LetterRequestCustomer_Schedule_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterRequestCustomerSchedule/GetModir?token=" + Token).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_Schedule_Interface>
      })
    )
  }

  GetModirSignle(Token: String,id:number): Observable<LetterRequestCustomer_Schedule_Interface> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterRequestCustomerSchedule/GetModirSignle?token=" + Token +"&id="+id).pipe(
      map(data => {
        return data as LetterRequestCustomer_Schedule_Interface
      })
    )
  }

}
